module.exports = __webpack_public_path__ + "static/media/placeholder.e47f04f8.png";